
export interface Plan {
    id?: string;
    planName: string;
    planType: PLANTYPE;
    planStatus?: PLANSTATUS;
    settings?: CodeValue[];
    startYr?: number;
    endYr?: number;
    planClients: PlanClient[];
    planAccounts?: PlanAccount[];
    planLiabilities?: PlanLiability[];
    goals: Goal[];  
    incomes?: Income[];
    expenses?: Expense[];
    savings?: Saving[];
    currentAlloc: Model;
    targetAlloc: Model;
    accounts?: string;
    clients?: string;
    createdBy?: string;
    createdDt?: string;
    updatedBy?: string;
    updatedDt?: string;
    poolId?: string[];
    version?: any;    
    planSaveError?: boolean;
    planResultViewBy?: PLANRESULTVIEWBY;
}

export enum PLANSTATUS
{
    'NULL' = 'NULL',
    'Active' = 'Active',
    'Deleted' = 'Deleted'
}

export enum PLANTYPE
{
    'NULL' = 'NULL',
    'Base' = 'Base',
    'WhatIf' = 'WhatIf'
}

export interface CodeValue {
    code: string;
    value: string;
}

export enum SETTINGSCODE {
    INC_TX_RT = 'INC_TX_RT',
    INF_RT = 'INF_RT',
    DISCOUNT_RT = 'DISCOUNT_RT',
    PRE_INC_TX_RT = 'PRE_INC_TX_RT',
    POST_INC_TX_RT = 'POST_INC_TX_RT',
    PRE_CG_TX_RT = 'PRE_CG_TX_RT',    
    POST_CG_TX_RT = 'POST_CG_TX_RT',
    EXP_SPENDING_PATTERN = 'EXP_SPENDING_PATTERN',
    PLAN_RESULT_VIEW_BY = 'PLAN_RESULT_VIEW_BY'
}

export interface PlanClient {
    clientid: string;
    clientname: string;
    initials?: string;
    legalEntityType?: string;
    dob?: string;
    age?: number;
    endAge?: number;
    gender?: string;
    stateOfResi?: string;    
    role: CLIENTROLE;
    retAge?: number;
    salary?: number;
    empType?: EMPLOYMENTTYPE;
    isIncluded?: boolean;
}

export enum CLIENTROLE {
    'NULL' = 'NULL',
    'Primary' = 'Primary',
    'Secondary' = 'Secondary',
    'Joint' = 'Joint',
    'Trust' = 'Trust',
    'Other' = 'Other'

}

export enum GENDER
{
    'NULL' = 'NULL',
    'M' = 'M',
    'F' = 'F'
}

export enum SMOKER {
    'Y' = 'Y',
    'N' = 'N'
}

export interface PlanAccount {
    actNo: string;
    custodian?: CUSTODIANTYPE;
    allocation?: number;
    depletionOrder?: number;
    clientid?: string;
    isIncluded: boolean;
}

export interface PlanLiability {
    actNo: string;
    custodian?: CUSTODIANTYPE;
    allocation?: number;
    depletionOrder?: number;
    clientid?: string;
    isIncluded: boolean;
}

export enum CUSTODIANTYPE {
    'Internal' = 'Internal',
    'External' = 'External',
    'HypoEA' = 'HypoEA'
}

export interface Goal {
    goalId?: string;
    goalType: GOALTYPE;
    goalDesc: string;
    priority?: number;
    startYr?: number;
    endYr?: number;
    incomes?: string[];
    expenses?: string[];
    accounts?: PlanAccount[];
    amount?: number;
    color?: string;
    isIncluded?: boolean;
}

export enum GOALTYPE {
    'NULL' = 'NULL',
    'LIV' = 'LIV',
    'PAS' = 'PAS',
    'FAM'= 'FAM',
    'LGY' = 'LGY',
    'COM' = 'COM'
}

export interface Income {    
    incId?: string;
    incSource?: INCOMESOURCE;
    incType: INCOMETYPE;
    incTypeDesc?: string;
    incDesc: string;
    owner: string;
    ownerName?: string;
    growthType?: GROWTHTYPE;
    growthRate?: number;
    amtPeriod: AmountPeriod[];
    isMonthly?: boolean;
    ssBenefitType?: SSBENEFITTYPE;
    isTaxable?: boolean;
    isAdjToFutureDollar?: boolean;
    isIncluded: boolean;
}

export enum INCOMESOURCE {
    'NULL' = 'NULL',
    'Ordinary' = 'Ordinary' ,
    'Investment'  = 'Investment'
}

export enum INCOMETYPE {
    'NULL' = 'NULL',
    'EI' = 'EI', //Employment Income         
    'SE' = 'SE', //Self-Employment Income         
    'IN' = 'IN', //Interest
    'SS' = 'SS', //Social Security - Need income data structure update
    'PA' = 'PA', //Pension
    'AN' = 'AN', //Annuity  - Need Income data structure update
    'AL' = 'AL', //Alimony
    'OT' = 'OT' //Other
}

export enum OWNERTYPE {
    'NULL' = 'NULL',
    'Single' = 'Single',
    'Joint' = 'Joint'
}

export enum GROWTHTYPE {
    'NULL' = 'NULL',
    'MNF' = 'MNF',
    'INF' = 'INF'
}

export interface AmountPeriod {
    startType: AMOUNTPERIODTYPE;
    startYr?: number;
    startAge?: number;
    amount?: number;
    endType: AMOUNTPERIODTYPE;
    endYr?: number;
    endAge?: number;
    duration?: number;
}

export enum AMOUNTPERIODTYPE {
    'NULL' = 'NULL',
    'Year' = 'Year',
    'AtRet' = 'AtRet',
    'Age' = 'Age',
    'AtEnd' = 'AtEnd',
    'Duration' = 'Duration'
}

export interface Expense {   
    expId: string;
    expType: EXPENSETYPE;
    expDesc: string;
    owner: string;
    growthType: GROWTHTYPE;
    growthRate?: number;
    isAdjToFutureDollar?: boolean;
    amtPeriod: AmountPeriod[]; 
    isIncluded?: boolean;
}

export enum EXPENSETYPE {
    'NULL' = 'NULL',
    'HSG' = 'HSG',//Housing
    'TPT' = 'TPT',//Transportation
    'HLC' = 'HLC',//Health Care
    'INP' = 'INP',//Insurance Premium
    'PE' = 'PE',//Personal
    'GRC' = 'GRC',//Grocery
    'FD' = 'FD',//Food
    'TRL' = 'TRL',//Travel
    'ENT' = 'ENT',//Entertainment
    'EDU' = 'EDU', // Education
    'LGY' = 'LGY', //Legacy
    'OTH' = 'OTH', //Other
}

export enum TAXSTATUS {
    'TAXABLE' = 'TAXABLE',
    'TAXDEFERRED' = 'TAX-DEFERRED',
    'TAXEXEMPT' = 'TAX-EXEMPT'
}

export enum TAXSTATUSCODE {
    'ALL' = 'ALL',
    'TX' = 'TX',
    'TD' = 'TD',
    'TE' = 'TE'
}

export interface Saving {  
    savId: string;  
    savType: SAVINGSTYPE
    savDesc: string;
    actId: string;
    owner: string;
    growthType: GROWTHTYPE;
    growthRate: number;
    amtPeriod: AmountPeriod[]; 
    isMonthly: boolean;    
    isIncluded: boolean;
}

export enum SAVINGSTYPE {
    'NULL' = 'NULL',
    'SC' = 'SC', //Self contribution
    'EC' = 'EC' //Employer Contribution
}

export interface Model {
    modelType: MODELTYPE;
    modelId: string;
    allocations: Allocation[];
}

export enum MODELTYPE {
    'CURRENT' = 'CURRENT',
    'MANAGED' = 'MANAGED',
    'FIRM' = 'FIRM',
    'CUSTOM'= 'CUSTOM'  
}

export interface Allocation{
    code: string;
    pct: number;
    desc?: string;    
    color?: string;
}

export enum HEALTHCONDITION
{
    'Excellent' = 'Excellent',
    'Average' = 'Average',
    'Poor' = 'Poor'
}

export enum EMPLOYMENTTYPE {
    'NONE' = 'NONE',
    'NOW' = 'NOW', //Not working
    'EMP' = 'EMP', //Employed
    'SEMP' = 'SEMP', //Self-employed 
    'RET' = 'RET' //Retired
}

export enum ENASEVERITY
{
    'NULL' = 'NULL',
    'Error' = 'Error',
    'Warning' = 'Warning',
    'Assumption' = 'Assumption'
}

export enum SSBENEFITTYPE {
    'NONE' = 'NONE',
    'MANUAL' = 'MANUAL',
    'EST' = 'EST'    
}

export enum LIFEEVENTTYPES {
    'RET' = 'RET',
    'END' = 'END',
    'RETASTELG' = 'RETASTELG',
    'SSELG' = 'SSELG',
    'MAXSS' = 'MAXSS',
    'RMDELG' = 'RMDELG',
    'MEDCRELG' = 'MEDCRELG'
}

export interface GoalAnalysisRequestParam {
    cashFlowProjType?: CASHFLOWPROJTYPE;
    goalSmryReq?: boolean;
    isPlanAnalytics?: boolean;
    isGoalAnalytics?: boolean;
    goalId?: string[];
}

export enum CASHFLOWPROJTYPE {
    'FULL' = 'FULL',
    'EXPENSE' = 'EXPENSE',
    'INCOME' = 'INCOME'
}

export const DEFAULTS = {
    retAge: 67,
    endAge: 90,
    ssStart: 67,
    anStart: 67,    
    ssAmount: 40000, // annually //3148 - monthly
    maxContribLimit: 1000000
}


export enum ERRORCODE {
    'APIERROR' = 'APIERROR',
    'LOCALAPIERROR' = 'LOCALAPIERROR'
}

export enum MSGTYPE {
    'NULL' = 'NULL',
    'INFO' = 'INFO',
    'WARNING' = 'WARNING',
    'ERROR' = 'ERROR',
    'SUCCESS' = 'SUCCESS'    
}

export enum COMPONENTTYPES  {
    'NONE' = 'NONE',    
    'CLIENTREL' = 'CLIENTREL',
    'CASHFLOWS' = 'CASHFLOWS',
    'CASHFLOWSTABLE' = 'CASHFLOWSTABLE',
    'NETCASHFLOWSBYYEAR' = 'NETCASHFLOWSBYYEAR',
    'ASSETPROJ' = 'ASSETPROJ',
    'GOALS' = 'GOALS',
    'GOALDETAILS' = 'GOALDETAILS',
    'EXPLIST' = 'EXPLIST',
    'ACCLIST' = 'ACCLIST',
    'LBACCLIST' = 'LBACCLIST',
    'INCLIST' = 'INCLIST',
    'MILESTONE' = 'MILESTONE',
    'INCOME' = 'INCOME',
    'FAMILYVIEW' = 'FAMILYVIEW',
    'TAXPORT' = 'TAXPORT'
}

export enum OPENDIALOGACTIONS {
    "CREATEPLAN" = "CREATEPLAN",
    "SAVEPLAN" = "SAVEPLAN",
    "DELETEPLAN" = "DELETEPLAN",
    "ADDEXPENSE" = "ADDEXPENSE",
    "EDITEXPENSE" = "EDITEXPENSE",
    "DELETEEXPENSE" = "DELETEEXPENSE",
    "ADDINCOME" = "ADDINCOME",
    "EDITINCOME" = "EDITINCOME",
    "DELETEINCOME" = "DELETEINCOME",
    "ADDSAVING" = "ADDSAVING",
    "EDITSAVING" = "EDITSAVING",
    "ACCOUNTS" = "ACCOUNTS",
    "EDITCLIENT" = "EDITCLIENT",
    "REMOVECLIENT" = "REMOVECLIENT",
}

export enum GUIDTYPE {
    "RCMEXP" = "RCMEXP",
    "RCMGOAL" = "RCMGOAL",
    "RCMINC" = "RCMINC",
    "RCMSAV" = "RCMSAV"
}
export enum KEYREF {
    "PreRetIncomeTxRt" = "PreRetIncomeTxRt",
    "PostRetIncomeTxRt" = "PostRetIncomeTxRt",
    "PreRetCGTxRt" = "PreRetCGTxRt",
    "PostRetCGTxRt" = "PostRetCGTxRt",    
    "InflRt" = "InflRt",
    "DiscountRt" = "DiscountRt",
    "ExpSpendingPattern" = "ExpSpendingPattern",
    "DefaultEndAge" = "DefaultEndAge",
    "DefaultRetAge" = "DefaultRetAge",
    "DefaultCostBasis" = "DefaultCostBasis",
    "MaxAllowedLoss" = "MaxAllowedLoss",
    "GuaranteedIncomeCd" = "GuaranteedIncomeCd", // multiple values comma seperated 
    "RetAstElig" = "RetAstElig",
    "SSStart"  = "SSStart",
    "SSMax" = "SSMax",
    "MedicareStart" = "MedicareStart",
    "RMDStart" = "RMDStart",
    "RMDDistFactor" = "RMDDistFactor" //multiple values as an array from 70 to 115

}

export enum PLANNINGUIREFTYPE {
    "EmploymentTypes" = "EmploymentTypes",
    "Settings" = "Settings",
    "GrowthRates" = "GrowthRates",
    "StartType" = "StartType",
    "EndType" = "EndType",
    "Goals" = "Goals",
    "GoalsPriority" = "GoalsPriority",
    "Expenses" = "Expenses",
    "Incomes" = "Incomes",
    "Savings" = "Savings",
    "IncomeChart" = "IncomeChart",
    "PrimaryIncomeColors" = "PrimaryIncomeColors",
    "SecondaryIncomeColors" = "SecondaryIncomeColors",
    "JointIncomeColors" = "JointIncomeColors",
    "GoalsColor" = "GoalsColor",
    "ClientsColor" = "ClientsColor",
    "Colors" = "Colors",
}

export enum DELETETYPE{
    "Plan" = "Plan",
    "Goal" = "Goal",
    "Expense" = "Expense",
    "Income" = "Income",
    "Client" = "Client"
}

export enum COLORS{
    "INCOME" = "INCOME",
    "ASSETS" = "ASSETS",
    "TAXABLE" = "TAXABLE",
    "TAXDEFERRED" = "TAXDEFERRED",
    "TAXEXEMPT" = "TAXEXEMPT"
}

export enum CHARTSERIESTYPE{
    "AGE" = "AGE",
    "INCOME" = "INCOME",
    "BALANCEBYTAXSTATUS" = "BALANCEBYTAXSTATUS",
    "WITHDRAWALBYTAXSTATUS" = "WITHDRAWALBYTAXSTATUS",    
    "NETCASHFLOWSBYTEAR" = "NETCASHFLOWSBYTEAR",
    "CASHFLOWTABLE" = "CASHFLOWTABLE",
    
}

export enum CHARTSERIESNAME{
    "Age" = "Age",
    'TAXABLE' = 'TAXABLE',
    'TAXDEFERRED' = 'TAX-DEFERRED',
    'TAXEXEMPT' = 'TAX-EXEMPT',
    "TotalExpense" = "Discretionary Expense",
    //"TotalExpense" = "Total Expense",
    "EssentialExpense" = "Essential Expense",
    "IncomeTaxes" = "Taxes",
    "Low" = "Low",
    "Medium" = "Medium",
    "High" = "High",
    "Range" = "Range"
    
}

export interface ChartSeries{
    chartSeriesType: CHARTSERIESTYPE;
    series: any;
    portfolioValue?: number;
    nCFAdditionalOutput?: NetCashFlowOutput;    
}
export interface ChartSeriesReqParam{
    chartSeriesType: CHARTSERIESTYPE;
    client?: string[];
    taxStatus?: TAXSTATUSCODE;
    year?: number;
}

export interface NetCashFlowOutput{
    portEndBal: number;
    portBeginBal: number;
    c1RetYear: number;
    c2RetYear?: number;
}


export interface AccRef {
    codeMasterId: number;
    code: string;
    name: string;
    assetGroup: number;
    assetCategory?: number;
    rmd?: string;
    contributionLimit?: number;
    catchup?: number;
    limitWithEm?: number;
    taxStatus?: string;    
}


export enum PLANRESULTVIEWBY{
    "PV" = "PV",
    "FV" = "FV"    
}